import React, { useState, useEffect } from "react";
import { useNavigation } from '@react-navigation/native'; // esto te sirve para navegar en el ambiente donde invocaste este componente
import {
  View,
  StyleSheet,
  TouchableWithoutFeedback,
  FlatList
} from "react-native";
import Modal  from "react-native-modal";
import { MaterialCommunityIcons, 
    AntDesign, 
    Fontisto,
    Ionicons, 
    Octicons, 
    FontAwesome,
    FontAwesome5,
    Foundation, 
    Entypo,
    MaterialIcons,
    SimpleLineIcons  } from "@expo/vector-icons";

import dateNow from "../utility/dateNow";
import dateActions from "../utility/dateActions";
import defaultStyles from "../config/styles";
import Button from "../components/Button";
import Text from "../components/Text";
import colors from "../config/colors";
//import { ListItemSeparator } from "../components/lists";
import routes from "../navigation/routes";
import configurationPost from "../config/configurationPost";
import connectionConfig from "../config/settings";
import Icon from "./Icon";
import CardListTypeActions from "./CardListTypeActions";

var newType = 0


function ChooseTypeContent ( props, route ) {
    //debugger
    var type = String(props.type)
    var seedId = props.seedId  //String(props.seedId)
    var origin = String(props.origin)
    var foundUserChecker = String(props.foundUserChecker)
    var changeListing = 'true'
    var seedDate = props.seedDate
    var userId = props.userId

    var newSeedDate = ''
    var showEdit = 'off'
    var date = dateNow()
    var newSeedId = 0
    var content = props.content
    var seedOrder = props.seedOrder
    var alterOrigin = ''
    var itemsRequirements = props.itemsRequirements
  

    const [modalVisible, setModalVisible] = useState(false);
    const [listing, setListing] = useState([]);
    const [uploadVisible, setUploadVisible] = useState(false);
    const [showDelete, setShowDelete] = useState(false);

    const navigation = useNavigation(); // esto te sirve para navegar en el ambiente donde invocaste este componente
 
    if(type < 33){showEdit = 'off'}
    if(type >= 33){showEdit = 'on'}


    useEffect(() => {
      //debugger
      date = dateNow()
      setListing(route.params)
    }, []);


const defineOrigin = async (newType) => {
  console.log("props.type ", props.type)
  if(props.type < 9 && props.type > -1) {
    alterOrigin = props.seedId} else {alterOrigin = origin} 
    generateActionId(newType)  
    console.log("alterOrigin ", alterOrigin)
}

//---------------------------------------------------
// Función para generar el seedId para el componente
//---------------------------------------------------
const generateActionId = async (newType) => {
 
 seedDate = date
 type = newType
 //origin = (type<9) ? origin = props.seedId : origin = origin 
 console.log("alterOrigin props.seedId ", alterOrigin, props.seedId)
 userId = props.userId

 var post_values = {
     userId           : userId,
     createDateSeed   : date,
     type             : newType,
     origin           : alterOrigin,       //origin,
     seedName         : 'Título... ',
     seedDescription  : 'Descripción... ',
     seedPhoto        : 'Poner Foto ',
     documentSeed     : 'Poner documento',
     youtubeId        : 'link',
     seedOrder        : orderAverage

   }
   configurationPost.body = JSON.stringify(post_values)
   await fetch(connectionConfig.apiUrl+'/insertAction/', configurationPost)
   .then(response => response.json())
   .then(response => {
     console.log( {response} + "Response despues de post GenerateActionId ChooseTypeContent")
     newSeedId = response.data.insertId
     seedId = newSeedId
     console.log("Este es el nuevo seedId desde ChooseTypeContent: " + newSeedId)
   })
   .catch(err =>{
     console.log('update fixo failed :( review internet service /insertAction/', err )
   })
   selectInfoAction(newType)
};


    const selectInfoAction = async (newType) => {
      seedId = newSeedId
      foundUserChecker = String(props.foundUserChecker)
      seedDate = date
      type = newType
      origin = origin
      seedOrder = orderAverage
      var screen = 'ChooseTypeContent'
       setModalVisible(false)
       navigation.navigate(routes.ACTION_EDIT_SCREEN, { type, seedId, origin, foundUserChecker, changeListing, seedDate, seedOrder, screen, itemsRequirements} ) 
    }


    const selectInfoActionEdit = async (type, seedOrder) => {
      seedId = seedId
      foundUserChecker = String(props.foundUserChecker)
      seedDate = seedDate
      type = type
      var screen = 'ChooseTypeContent'
      setModalVisible(false)
       navigation.navigate(routes.ACTION_EDIT_SCREEN, { type, seedId, origin, foundUserChecker, changeListing, seedDate, seedOrder, seedPhoto, screen, itemsRequirements } ) 
    }

// ***************************************************************************************** 
//         Inicia secuencia de pasos para obtener el seedOrder y mandarlo a CardEdit
// *****************************************************************************************
      var processSeedOrder = {}
      var findSeedOrder = {}
      var result = {}
      var processSeedPhoto = ''

    const pickSeedOrder0 = async (type) => {
      detectSeedIndex()
      console.log("indexSeed en pickSeedOrder0 ", indexSeed)
      pickSeedOrder1(type)
    }   
    const pickSeedOrder1 = async (type) => {
      result =
      findSeedOrder.push = ( 
        content.find((item) => (item.seedOrder === content[ indexSeed ].seedOrder))
      );
      processSeedOrder = findSeedOrder.push.seedOrder
      processSeedPhoto = findSeedOrder.push.seedPhoto
      seedOrder = processSeedOrder
      seedPhoto = processSeedPhoto
      selectInfoActionEdit(type, seedOrder)
    }
// ***************************************************************************************** 


//******************************************************************************************
//              Inicia sección para hacer el Insert Up or Down de componentes
//******************************************************************************************
// Esto a continuación es un ejemplo de como si jalaba el map aunque después no lo utilice...
// var contentResumen = {};
// var contentSeedIdPlusCreateDate = content.map((item) => { 
//   contentResumen.push = ( 
//     {
//       seedId: item.seedId,
//       createDateSeed: item.createDateSeed,
//     }
//   )
//   return contentResumen;
//   });
 //console.log("contentSeedIdPlusCreateDate ", contentSeedIdPlusCreateDate)

var totalIndex =   Object.keys(content).length // ===> Esto nos da el length del array content
var findIndexDown = {}
var indexDown = {}
var indexReDown = {}
var orderAverage = ''
var indexSeed = ''
var typeActionSelect =''

const checkUploadVisible = async (newType) => {
  if(props.type >= 0 && props.type < 10) {
    setUploadVisible(false)
    insertDownSeed(newType)
  } 
  else if (newType >= 33 && uploadVisible === false) {
    type = newType
    setUploadVisible(true)
  }
  else {setUploadVisible(false)}
}

// Esta función es llamada más abajo para determinar el seed index del cual dimos click el ChooseTypeContent 
const detectSeedIndex = async () => {
  var insertContent = "down"
  indexSeed = content.findIndex((element) => (element.seedId === seedId ) );  //String(props.seedId)
  if(insertContent === "down"){
    console.log("indexSeed en ChooseType ", indexSeed, "seedId ", String(props.seedId))
  }
  console.log("resta de indexes ", totalIndex - indexSeed)
}

// Esta función aplica para cuando seleccionamos insertar algo a un contenido y lo que hace es 
// cachar si seleccionamos insertar arriba o abajo y mandarnos a la función correspondiente. 
const selectingUpOrDown = async (newType) => {
  if(typeActionSelect === 1){
    console.log("insertUp")
    insertUp(newType)}
  if(typeActionSelect === 2){
    console.log("insertDown")
    insertDown(newType)}
  if(typeActionSelect === 3){console.log("Aqui luego ira un navigate a un video explicador shulo")}
}

// Función para insertar contenido arriba de cierto contenido.
const insertUp = async (newType) => {
  detectSeedIndex()
  findIndexDown = {}
  if((totalIndex - indexSeed)===1){
    indexDown = 
     findIndexDown.push = ( 
       content.find((item) => (item.seedId === content[ indexSeed ].seedId))
     );
     indexReDown = 
     findIndexDown.push = ( 
       content.find((item) => (item.seedId === content[ indexSeed - 1 ].seedId))
     );
     console.log("indexDown y ReDown en el primer if => ", indexDown.seedOrder, " ", indexReDown.seedOrder)
     orderAverage = (indexDown.seedOrder + indexReDown.seedOrder)/2  
     console.log("orderAverage ", orderAverage, "seedId", props.seedId)
    }
    else if((totalIndex - indexSeed)>1){
      indexDown = 
       findIndexDown.push = ( 
         content.find((item) => (item.seedOrder === content[ indexSeed ].seedOrder))
       );
       indexReDown = 
       findIndexDown.push = ( 
         content.find((item) => (item.seedOrder === content[ indexSeed - 1 ].seedOrder))
       );
       console.log("indexDown y ReDown en el primer if => ", indexDown.seedOrder, " ", indexReDown.seedOrder)
       orderAverage = (indexDown.seedOrder + indexReDown.seedOrder)/2  
       console.log("orderAverage ", orderAverage, "seedId", props.seedId)      }
      else{
         indexDown = 
          findIndexDown.push = ( 
            content.find((item) => (item.seedId === content[ indexSeed ].seedId))
          );
          orderAverage = (props.seedId + indexDown.seedOrder)/2  
         }
// I M P O R T A N T E : orderAverage es lo que ordenará arriba o abajo el nuevo contenido.
defineOrigin(newType)
}

// Función para insertar contenido abajo de cierto contenido.
const insertDown = async (newType) => {
  detectSeedIndex()
  findIndexDown = {}
  if((totalIndex - indexSeed)===1){
    indexDown = 
     findIndexDown.push = ( 
       content.find((item) => (item.seedId === content[ indexSeed ].seedId))
     );
     
     console.log("indexDown y ReDown en el primer if => ", indexDown.seedOrder, " ", indexReDown.seedOrder)
     orderAverage = indexDown.seedId + 1  
     console.log("orderAverage ", orderAverage, "seedId", props.seedId)
    }

  else if((totalIndex - indexSeed)>1){
  indexDown = 
   findIndexDown.push = ( 
     content.find((item) => (item.seedId === content[ indexSeed ].seedId))
   );
  indexReDown = 
   findIndexDown.push = ( 
     content.find((item) => (item.seedId === content[ indexSeed + 1 ].seedId))
   );
   console.log("indexDown y ReDown en el primer if => ", indexDown.seedOrder, " ", indexReDown.seedOrder)
   orderAverage = (indexDown.seedOrder + indexReDown.seedOrder)/2  
   console.log("orderAverage ", orderAverage, "seedId", props.seedId)
  } else{
    indexDown = 
   findIndexDown.push = ( 
     content.find((item) => (item.seedId === content[ indexSeed ].seedId))
   );
   orderAverage = (props.seedId + indexDown.seedId)/2  
   console.log("orderAverage ", orderAverage)
  } 
 console.log("indexDown ", indexDown.seedId)
// I M P O R T A N T E : orderAverage es lo que ordenará arriba o abajo el nuevo contenido.
defineOrigin(newType)
}

// Función para insertar contenido abajo de una semilla o acción del 1 al 9.
const insertDownSeed = async (newType) => {
  detectSeedIndex()
  findIndexDown = {}
  if((totalIndex - indexSeed)===1 ){
     orderAverage = props.seedId + 1  
     console.log("orderAverage seed o acción ", orderAverage)
    }
  else if((totalIndex - indexSeed) > 1 ){
  indexDown = 
  findIndexDown.push = ( 
    content.find((item) => (item.seedId === content[ indexSeed ].seedId))
  );
 indexReDown = 
  findIndexDown.push = ( 
    content.find((item) => (item.seedId === content[ indexSeed + 1 ].seedId))
  );
  console.log("indexDown y ReDown en el primer if => ", indexDown.seedOrder, " ", indexReDown.seedOrder)
  orderAverage = (indexDown.seedOrder + indexReDown.seedOrder)/2  
  console.log("orderAverage ", orderAverage, "seedId", props.seedId)
  }else{
    indexDown = 
   findIndexDown.push = ( 
     content.find((item) => (item.seedId === content[ indexSeed ].seedId))
   );
   orderAverage = (props.seedId + indexDown.seedId)/2  
   console.log("orderAverage ", orderAverage)
  } 
defineOrigin(newType)
}
//******************************************************************************************
//              Termina sección para hacer el Insert Up or Down de componentes
//******************************************************************************************

// Función para ELIMINAR dependiendo de si es semilla, acción o contenido. 
const chooseDelete = async () => {
  if(props.type >= 0 && props.type < 10) {
    setShowDelete(true)
  } 
  else if(props.type >= 33) {
    setShowDelete(true)
  }
}

const deleteMethod = async (newType) => {
  if(typeActionSelect === 1 && type < 10 ){
    console.log("Poner en anónimo semilla o acción")
  }
  if(typeActionSelect === 2 && type < 10){
    console.log("Poner en anónimo semilla o acción y guardar")
  }
  if(typeActionSelect === 1 && type > 10){
    console.log("Mandar componente a guardar")
  }
  if(typeActionSelect === 2 && type > 10){
    console.log("Eliminar de plano componente")
  }
}



// Este arreglo es para las opciones del Flat List para insertar Up o Down
const menuDownUp = [
  {
    typeActionsId   :  1,
    title           :  "Arriba",
    iconFamily      :   "FontAwesome5",
    icon            :   "arrow-up",
    background      :   colors.pistache,
    backgroundColor :   colors.black
  },
  {
    typeActionsId   :  2,
    title           :  "Abajo",
    iconFamily      :   "FontAwesome5",
    icon            :   "arrow-down",
    background      :   colors.pistache,
    backgroundColor :   colors.black
  },
  {
    typeActionsId   :  3,
    title           :  "Ayuda, no entiendo.",
    iconFamily      :   "Entypo",
    icon            :   "help",
    background      :   colors.pistache,
    backgroundColor :   colors.black
  }
]
  
// Este arreglo es para las opciones del Flat List para insertar Up o Down


const menuDelete = [
  {
    typeActionsId   :  1,
    title           :   "Si guardar por favor", //"Poner en anónima y guardar",
    iconFamily      :   "MaterialCommunityIcons",
    icon            :   "eye-circle",
    background      :   colors.pistache,
    backgroundColor :   colors.black
  },
  {
    typeActionsId   :  2,
    title           :  "No guardar, gracias", //"Sólo hacerla anónima",
    iconFamily      :   "AntDesign",
    icon            :   "closecircle",
    background      :   colors.pistache,
    backgroundColor :   colors.black
  }
]

console.log("type en ChooseTypeContent ", type)

    return (
      <>
        <TouchableWithoutFeedback onPress={() => setModalVisible(true)}>
          <View style={styles.ViewThreePoints}>
            <SimpleLineIcons style={styles.ThreePoints}
              name="options"
              size={22}
              color="white"
            />
            <SimpleLineIcons style={styles.ThreePoints}
              name="options-vertical"
              size={22}
              color={defaultStyles.colors.medium}
            />
          </View>
        </TouchableWithoutFeedback>
                <Modal style={styles.Modal} 
                       visible={modalVisible} 
                       transparent={true} 
                       backDropOpacity="0.8"
                       animationType="fade">

              {   // Para seleccionar si se Edita arriba o abajo
                              uploadVisible === true ?
                              <View style={styles.ViewflatlistTypeAction}>
                                    <Text style={styles.textTitleFlatlistUpDown}> 
                                Hola ¡
                                </Text>
                                <Text style={styles.textTitleFlatlistUpDown}> 
                                ¿Dónde deseas que quede insertado este nuevo contenido? 
                                </Text>
                              <FlatList
                                data={menuDownUp}
                                keyExtractor={(item) => item.typeActionsId.toString()}
                                //ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.title}
                                    backgroundColor = {item.background}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      //newType = 33
                                      //type = newType
                                      date = dateNow()
                                      newSeedDate = dateActions(date)
                                      typeActionSelect = menuDownUp[index].typeActionsId
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      selectingUpOrDown(newType)
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.ButtonCancel}
                              onPress={() =>{ 
                                setUploadVisible(false)
                              }}>Regresar</Text>
                              </View>
                              :
                              null
                            }
              {   // Para seleccionar si se Elimina u Oculta
                              showDelete === true ?
                              <View style={styles.ViewflatlistTypeAction}>
                                { type < 10 ?
                                  <>
                                  <Text style={styles.textTitleFlatlistUpDown}> 
                                  Las semillas o acciones no se eliminan porque pueden tener dependencias¡ Pero se hacen anónimas.
                                  </Text>
                                  <Text style={styles.textTitleFlatlistUpDown}> 
                                  Además de ponerla en anónima se puede guardar en tu carpeta.
                                  </Text>
                                  </>
                                  :
                                  <>
                                  <Text style={styles.textTitleFlatlistUpDown}> 
                                  Hola, si eliminas esto será para siempre¡ 
                                  </Text>
                                  <Text style={styles.textTitleFlatlistUpDown}> 
                                  No prefieres guardar y verlo solamente tú?
                                  </Text>
                                  </>
                                }
                              <FlatList
                                data={menuDelete}
                                keyExtractor={(item) => item.typeActionsId.toString()}
                                //ItemSeparatorComponent={ListItemSeparator}
                                renderItem={({ item, index }) => (
                                  <CardListTypeActions
                                    title ={item.title}
                                    backgroundColor = {item.background}
                                    IconComponent={
                                      <Icon
                                        iconFamily={item.iconFamily}
                                        name={item.icon}
                                        size ={35}      //{item.size}
                                        backgroundColor={item.backgroundColor}
                                      />
                                    }
                                    onPress={() =>{ 
                                      date = dateNow()
                                      newSeedDate = dateActions(date)
                                      typeActionSelect = menuDelete[index].typeActionsId
                                      console.log("typeActionSelect==> ", typeActionSelect)
                                      console.log("type ==> ", type)

                                      deleteMethod()
                                    }}
                                  />
                                )}
                              />
                              <Text style={styles.ButtonCancel}
                              onPress={() =>{ 
                                //setUploadVisible(false)
                                setShowDelete(false)
                              }}>Regresar</Text>
                              </View>
                              :
                              null
              }

                    <View style={styles.Container} >                               
                 
                      { 
                        showEdit === 'on' ?  
                                   
                        <View style={styles.buttonsContainer}>
                        <Entypo style={styles.button}
                                name={"edit"}
                                color={"grey"} size={20} 
                                onPress={() => {
                                type = {type}
                                seedOrder = { seedOrder }
                                console.log("Click en Edit con type: ", type)
                                //selectInfoActionEdit(type) 
                                pickSeedOrder0(type)
                                }}
                                >
                            <Text style={styles.description}> EDIT </Text>
                            <View style={styles.separator} /> 
                        </Entypo>
                        </View>
                        : 
                        null
                      }
                        <View style={styles.buttonsContainer}>
                            <MaterialCommunityIcons style={styles.button}
                                name={"card-text-outline"}
                                color={"grey"} size={30} 
                                onPress={() => {
                                  {
                                    newType = 33
                                    type = newType
                                    date = dateNow()
                                    newSeedDate = dateActions(date)
                                    console.log("En onPress ChooseType ==> type, newSeedDate ", type, " ", newSeedDate)
                                  }
                                  (
                                    uploadVisible === false ?
                                    checkUploadVisible(newType)
                                    :
                                    checkUploadVisible(newType)
                                    )
                                }}
                                >
                                <Text style={styles.description}> Agrega Texto </Text>
                            </MaterialCommunityIcons>   
                        </View> 
                        <View style={styles.buttonsContainer}>
                                <Foundation style={styles.button}
                                name={"page-export-pdf"}
                                color={"grey"} size={30} 
                                onPress={() => {
                                  {
                                    newType = 34
                                    type = newType
                                    date = dateNow()
                                    newSeedDate = dateActions(date)
                                    console.log("En onPress ChooseType ==> type, newSeedDate ", type, " ", newSeedDate)
                                  }
                                  (
                                    uploadVisible === false ?
                                    checkUploadVisible(newType)
                                    :
                                    checkUploadVisible(newType)
                                    ) 
                                }}
                                >
                                <MaterialCommunityIcons style={styles.button}
                                name={"file-excel"}
                                color={"grey"} size={30} 
                                onPress={() => {
                                  {
                                    newType = 34
                                    type = newType
                                    date = dateNow()
                                    newSeedDate = dateActions(date)
                                    console.log("En onPress ChooseType ==> type, newSeedDate ", type, " ", newSeedDate)
                                  }
                                  (
                                    uploadVisible === false ?
                                    checkUploadVisible(newType)
                                    :
                                    checkUploadVisible(newType)
                                    )  
                                }}
                                ></MaterialCommunityIcons>
                                <Text style={styles.description}> Agrega Documento </Text>
                            </Foundation>  
                        </View> 
                        <View style={styles.buttonsContainer}>
                                <FontAwesome style={styles.button}
                                    name={"photo"}
                                    color={"grey"} size={30} 
                                    onPress={() => {
                                      {
                                        newType = 35
                                        type = newType
                                        date = dateNow()
                                        newSeedDate = dateActions(date)
                                        console.log("En onPress ChooseType ==> type, newSeedDate ", type, " ", newSeedDate)
                                      }
                                      (
                                        uploadVisible === false ?
                                        checkUploadVisible(newType)
                                        :
                                        checkUploadVisible(newType)
                                        ) 
                                    }}
                                    >
                                <Text style={styles.description}> Agrega Foto o Video </Text>
                                </FontAwesome>
                        </View> 
                        <View style={styles.buttonsContainer}>  
                                <MaterialCommunityIcons style={styles.button}
                                    name={"youtube"}
                                    size={25}
                                    color={"grey"}
                                    //style={styles.iconYoutube}
                                    onPress={() => {
                                      {
                                        newType = 38
                                        type = newType
                                        date = dateNow()
                                        newSeedDate = dateActions(date)
                                        console.log("En onPress ChooseType ==> type, newSeedDate ", type, " ", newSeedDate)
                                      }
                                      (
                                        uploadVisible === false ?
                                        checkUploadVisible(newType)
                                        :
                                        checkUploadVisible(newType)
                                        ) 
                                    }}
                                    >      
                                  <Text style={styles.description}> Agrega video de youtube  </Text>
                                </MaterialCommunityIcons>  
                        </View> 
                        <View style={styles.buttonsContainer}>        
                            <Ionicons  style={styles.button} 
                                     name={"ios-rocket"} 
                                     color={"grey"} 
                                     size={30} 
                                     onPress={() => {
                                      {
                                        newType = 39
                                        type = newType
                                        date = dateNow()
                                        newSeedDate = dateActions(date)
                                        console.log("En onPress ChooseType ==> type, newSeedDate ", type, " ", newSeedDate)
                                      }
                                      (
                                        uploadVisible === false ?
                                        checkUploadVisible(newType)
                                        :
                                        checkUploadVisible(newType)
                                        ) 
                                    }}
                                   >
                              <Text style={styles.description}> Agrega requerimiento </Text>
                            </Ionicons > 
                        </View>
                        <View style={styles.buttonsContainer}>        
                            <MaterialIcons  style={styles.button} 
                                     name={"place"} 
                                     color={"grey"} 
                                     size={30} 
                                     onPress={() => {
                                      type = 40
                                      selectInfoAction(type) 
                                    }}
                                   >
                              <Text style={styles.description}> Agrega ubicación </Text>
                            </MaterialIcons > 
                        </View> 
                        
                        {/* <View style={styles.buttonsContainer}>        
                            <AntDesign  style={styles.button}
                                           name={"heart"} 
                                           color={"grey"} 
                                           size={25} 
                                           onPress={() => {
                                            type = 41
                                            selectInfoAction(type) 
                                          }} 
                                    >
                             <Text style={styles.description}> Agrega resultados </Text>
                            </AntDesign > 
                            <ListItemSeparator/>
                       </View>  */}
                       
                       <View style={styles.buttonsContainer}>
                            <AntDesign style={styles.button}
                                name={"delete"}
                                color={"grey"} size={30} 
                                onPress={() => {
                                  {
                                    newType = 33
                                    type = newType
                                    date = dateNow()
                                    newSeedDate = dateActions(date)
                                    console.log("En onPress ChooseType ==> seedId, newSeedDate ", seedId, " ", newSeedDate)
                                  }
                                  (
                                    showDelete === false ?
                                    chooseDelete()
                                    :
                                    chooseDelete()
                                    )
                                }}
                                >
                                <Text style={styles.description}> Eliminar </Text>
                            </AntDesign>   
                        </View> 
                       <Button style={styles.ButtonCancel}
                       title="Cancel" 
                       onPress={() => setModalVisible(false)} 
                       color="green" /> 
          </View>
        </Modal>
      </>
    );
  }
  
  const styles = StyleSheet.create({
    textTitleFlatlistUpDown: {
      width: "93%",
      fontSize: 24,
      fontWeight: "500",
      color: "white",
      marginTop: "2%",
      marginLeft: "2%",
      marginBottom: "4%",
      padding: "2%", 
      textAlign: "center"
    },
    ViewflatlistTypeAction: {   // Esto es para el view de fondo del FlatList para elegir insertar DOWN o UP
      position: "absolute",
      zIndex: 1,
      width: "99%",
      height: "60%",
      marginLeft: "1%",
      marginTop: "10%",
      marginBottom: "30%",
      backgroundColor: colors.chakra1nar,
    },
    ViewThreePoints:{
      zIndex: 2,
      //marginTop: "20%"
      position: "absolute",
      marginBottom: "0.5%",
      flexDirection: "row",
    },
    ThreePoints:{
      //paddingTop: "2%",
      paddingRight: "-0.2%",
      marginLeft: 1,
    },
    Container: {
     // backgroundColor: defaultStyles.colors.light,
      paddingTop: "50%",
      marginBottom: "88%",
      marginLeft: "5%",
      width: "90%",
     // borderRadius: 25,
     // flexDirection: "row",
     // padding: 15,
      //marginVertical: 10,
      height: "50%",
      alignSelf: "baseline",
      backgroundColor: "rgba(0, 0, 0, 0)", // Con esto haces transparente el fondo 
    },
    icon: {
      marginRight: 10,
    },
    placeholder: {
      color: defaultStyles.colors.medium,
      flex: 1,
    },
    text: {
      flex: 1,
    },
    readyButton: {
      //fontSize:4,
      marginTop: 8,
      width:"50%",
      borderRadius: 25,
      justifyContent: "center",
      alignItems: "center",
      padding: 15,
      marginVertical: 10,
    },
    buttonsContainer: {
        flexDirection: "row",
        //width: "90%",
        backgroundColor: colors.transparent,

    },
    Modal: {
        //backgroundColor: "blue",
    },
    ButtonCancel: {
      backgroundColor: colors.lemonGreen,
      color: "white",
      fontSize: 25,
      alignSelf: "center",
      textAlign: "center",
      padding: "2%",
      borderRadius: 25,
      width: "100%"
    },
    button: {
      backgroundColor: colors.fuente,
      width: "95%",
      //height: "100%",
      padding: "1%",
      paddingLeft: "3%",
      marginLeft: "3%",
    },
    description: {
      padding: "3%",
    },
    separator: {
      width: "90%",
      height: 1,
      backgroundColor: colors.dark,
    },
  });
  
  export default ChooseTypeContent;
  

